function manipulateNewsletter() {
  const newsletter = document.querySelector(".container.footer-newsletter");
  if (!newsletter) return;
  const newsletterHeader = newsletter.querySelector(".newsletter-header");
  if (!newsletterHeader) return;
  const newsletterHeaderAppend = document.createElement("h4");
  newsletterHeaderAppend.classList.add("newsletter-header-h4");
  newsletterHeaderAppend.textContent = `Newsletter`;
  newsletterHeader.prepend(newsletterHeaderAppend);
}
